module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "existing_participant_modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("EXISTING " + _vm._s(_vm.participantSingularName.toUpperCase()) + " FOUND")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-body"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input has-warning"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', [_c('h4', [_c('b', [_vm._v("ALERT:")]), _vm._v(" We found an existing record. Please confirm your entry or\n                    select Add New\n                    " + _vm._s(_vm.participantSingularName) + " to proceed.")])])])]), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.foundUsers,
      "pagination-options": {
        enabled: true
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field === 'participant_name') ? _c('span', [(props.row.organization[0].id === _vm.user.organizations[0].id) ? _c('router-link', {
          attrs: {
            "to": {
              name: 'Dashboard Participant',
              params: {
                id: props.row.id
              }
            },
            "tag": "a",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        }, [_vm._v(_vm._s(props.row.participant_name) + "\n                  ")]) : _c('span', [_vm._v(_vm._s(props.row.participant_name))])], 1) : (props.column.field === 'date_completed.date') ? _c('span', [_vm._v(_vm._s(_vm._f("formatDateModalNoTimeZone")(props.row.date_completed && props.row.date_completed.hasOwnProperty('date') ? props.row.date_completed.date : '')))]) : (props.column.field === 'date_of_birth.date') ? _c('span', [_vm._v(_vm._s(_vm._f("formatDateModalNoTimeZone")(props.row.date_of_birth && props.row.date_of_birth.hasOwnProperty('date') ? props.row.date_of_birth.date : '')))]) : (props.column.field === 'organization') ? _c('span', [_vm._v(_vm._s(props.row.organization.map(function (item) { return item.name; }).join(',')))]) : (props.column.field === 'action') ? _c('span', [(!props.row.organization.map(function (item) { return item.id; }).includes(_vm.user.organizations[0].id)) ? _c('button', {
          staticClass: "btn btn-sm green",
          on: {
            "click": function($event) {
              return _vm.addParticipantFromAnotherOrganization(props.row.id)
            }
          }
        }, [_vm._v("Add")]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }])
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('router-link', {
    attrs: {
      "to": "/admin/participant"
    }
  }, [_c('button', {
    staticClass: "btn green",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('confirm')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n            Add New " + _vm._s(_vm.participantSingularName) + "\n          ")])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e11216f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ExistingParticipantModal.vue
// module id = 1662
// module chunks = 1